module.exports = __webpack_public_path__ + "static/media/mezie-ola-before.482109a6.JPG";